// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import React from "react";

// const gridItemStyles = {
//     css: css`
//         ${({ theme }) => {
//             return breakpointMediaQueries(theme, [
//                 css`
//                     align-items: center;
//                 `,
//                 css`
//                     align-items: center;
//                 `,
//                 css``,
//                 css``,
//                 css``,
//             ]);
//         }}
//     `,
// };

const CategoryDetailsContainer: React.FC<WidgetProps> = ({ id }: WidgetProps) => {
    return (
        <GridContainer>
            <GridItem width={[0, 0, 3, 3, 3]}>
                <Zone contentId={id} zoneName="Content1" />
            </GridItem>
            <GridItem width={[12, 12, 9, 9, 9]} align="middle">
                <Zone contentId={id} zoneName="Content2" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: CategoryDetailsContainer,
    definition: {
        group: "Basic",
        icon: "Banner",
    },
};

export default widgetModule;
